import styled from 'styled-components';

export const HeaderWrapper = styled.div`
  cursor: default;
  flex-shrink: 0;
`;

export const HeaderIconContainer = styled.div`
  position: relative;
  left: -0.5rem;
  padding-bottom: 1.25em;

  svg {
    color: ${({ theme }) => theme.color.chatPanel};
  }
`;
